import { html, View, type Html, rune } from 'rune-ts';
import klass from './CraftSection.module.scss';
import { ScrollState, SetScrollIndexEvent } from '../../HandmadeCreatorLandingPage';
import { CraftCard } from './CraftCard';
import { CRAFT_CARD_PROPS, ONE_SCROLL_INDEX_MAP_PC } from '../../const';
import { pipe, map, toArray } from '@fxts/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger.js';

interface CraftSectionData {
  scroll_state: ScrollState;
}

export class CraftSection extends View<CraftSectionData> {
  craftCardViews: CraftCard[];

  constructor(data: CraftSectionData) {
    super(data);
    this.craftCardViews = this._renderCraftCardList();
  }

  override template(): Html {
    return html` <section class="${klass.container}">${this.craftCardViews}</section> `;
  }

  private _renderCraftCardList() {
    return pipe(
      CRAFT_CARD_PROPS,
      map((craft_card_prop) => new CraftCard(craft_card_prop)),
      toArray,
    );
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    if (!is_mobile) this.initScaleScrollTrigger();
  }

  initScaleScrollTrigger() {
    gsap.utils.toArray(`.${klass.card}`).forEach((target, idx) => {
      ScrollTrigger.create({
        trigger: target,
        start: 'top top',
        end: 'bottom top',
        pin: true,
        pinSpacing: false,
        onEnter: () => {
          this.dispatchEvent(SetScrollIndexEvent, {
            bubbles: true,
            detail: { current_index: ONE_SCROLL_INDEX_MAP_PC.craft_index + idx },
          });
        },
        onEnterBack: () => {
          this.dispatchEvent(SetScrollIndexEvent, {
            bubbles: true,
            detail: { current_index: ONE_SCROLL_INDEX_MAP_PC.craft_index + idx },
          });
        },
      });
    });
  }
}
